import {useShowError} from "@hooks/useShowError/useShowError";
import {useQuery} from "@tanstack/react-query";
import {getSingleVoyagePlannedResourceApi} from "@containers/singleVoyage/containers/plannedResources/api";
import {IPropsGetPlannedResourcesSingleVoyage} from "@containers/singleVoyage/containers/plannedResources/types";
import {
    QUERY_KEY_SINGLE_VOYAGE_PLANNED_RESOURCES
} from "@containers/singleVoyage/containers/plannedResources/queryHooks/constants/queryKey";

export const usePlannedResourceSingleVoyageQuery = ({
                                                        params,
                                                        enabled,
                                                    }: {
    params: IPropsGetPlannedResourcesSingleVoyage,
    enabled?: boolean,
}) => {
    const {onShowError} = useShowError()

    return useQuery({
        queryFn: () => getSingleVoyagePlannedResourceApi(
            params,
            onShowError
        ),
        queryKey: [
            QUERY_KEY_SINGLE_VOYAGE_PLANNED_RESOURCES,
            params?.accountId,
            params?.plannedStart || 'all',
            params?.plannedEnd || 'all',
        ],
        staleTime: 1000 * 60 * 30,
        enabled: (typeof enabled !== 'undefined' ? enabled : true) && !!params?.accountId,
    });
}
